import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/about/page.js");
